import {
  getAtlasTheme, getPaletteForTheme, normalizeThemeMode, THEME_MODES, THEME_STORAGE_KEY,
} from "../theme";

// The console opens light where the public site opens dark: it is what the
// console has always looked like, and operators sit in it all day beside
// mail and spreadsheets. Only the default differs — the storage key is the
// one the rest of the app uses, so a choice made in either place carries
// over, and the topbar toggle still switches it.
export const ADMIN_DEFAULT_THEME_MODE = THEME_MODES.light;

export function getStoredAdminThemeMode() {
  if (typeof window === "undefined") {
    return ADMIN_DEFAULT_THEME_MODE;
  }

  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);

  return stored === THEME_MODES.dark || stored === THEME_MODES.light
    ? stored
    : ADMIN_DEFAULT_THEME_MODE;
}

// The console borrows gos-admin's shell proportions — a 56px sticky header
// lifted off the page by a soft shadow, a fixed-width sider and a 24px
// content inset — while every colour and typeface still comes from the
// Atlas palette in src/theme.js. Styles below the shell read the
// `--atlas-*` custom properties from global.css instead of these values,
// so they follow the light/dark switch without threading props.
export const adminShellMetrics = {
  headerHeight: 56,
  headerPadding: "0 16px",
  headerShadow: "0 1px 4px 0 rgb(0 21 41 / 12%)",
  logoSize: 34,
  contentInset: 24,
  siderWidth: 220,
};

export function getAdminTheme(themeMode) {
  const atlasTheme = getAtlasTheme(themeMode);
  const palette = getPaletteForTheme(themeMode);

  return {
    ...atlasTheme,
    cssVar: { key: `election-atlas-admin-${normalizeThemeMode(themeMode)}` },
    components: {
      ...atlasTheme.components,
      Layout: {
        ...atlasTheme.components.Layout,
        headerHeight: adminShellMetrics.headerHeight,
        headerPadding: adminShellMetrics.headerPadding,
        // The sider sits a shade off the page so the content column reads
        // as the foreground, the way gos-admin's does.
        siderBg: palette.backgroundAccent,
        triggerBg: palette.secondary,
        triggerColor: palette.foreground,
      },
    },
  };
}

export default getAdminTheme;
